var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLambda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#OrangeGradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "OrangeGradient",
    x1: -1788.05,
    y1: 692.67,
    x2: -1788.05,
    y2: 842.67,
    gradientTransform: "translate(-1769.67 -684.02) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8511b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AWS-Lambda") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reference"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Orange_Gradient",
    "data-name": "Orange Gradient",
    className: "cls-1",
    width: 75,
    height: 75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Test",
    "data-name": "Icon Test"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.5,62.5H48.18a1,1,0,0,1-.9-.57L29.86,25.5H22.49a1,1,0,0,1-1-1v-11a1,1,0,0,1,1-1H37.89a1,1,0,0,1,.9.57L56.13,49.5H60.5a1,1,0,0,1,1,1v11A1,1,0,0,1,60.5,62.5Zm-11.69-2H59.5v-9h-4a1,1,0,0,1-.9-.57L37.26,14.5H23.5v9h7a1,1,0,0,1,.9.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.48,62.5h-13a1,1,0,0,1-.85-.47,1,1,0,0,1-.05-1L27.18,32.62a1,1,0,0,1,.9-.57h0a1,1,0,0,1,.9.56L35.49,46a1,1,0,0,1,0,.87l-7.1,15A1,1,0,0,1,27.48,62.5Zm-11.4-2H26.85l6.63-14L28.09,35.35Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLambda);
export default __webpack_public_path__ + "static/media/lambda.941a1fdecf4b6e7b3f318ed37df6a21e.svg";
export { ForwardRef as ReactComponent };